import { render, staticRenderFns } from "./PatientGeneralInfoCard.vue?vue&type=template&id=35e93eb8&"
import script from "./PatientGeneralInfoCard.vue?vue&type=script&lang=js&"
export * from "./PatientGeneralInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports